import React from 'react'

const NotFound = () => {
    return <>404 Not Found</>
}

export default NotFound